<app-system-notification
  [visible]="showGracePeriodWarning"
  [title]="'Grace Period' | translate"
  [message]="'Your Discount addon has expired. You have ' + gracePeriodInfo?.daysRemaining + ' days left to renew before features are disabled.'"
  actionLabel="Renew Subscription"
  (action)="router.navigate(['/billing'])">
</app-system-notification>

<div class="genie-page">

  <!-- Page Header -->
  <div class="genie-page-header">
    <div class="header-left">
      <div class="backButton" (click)="builderService.navigateBack()">
        <img src="/assets/icons/arrow-left.svg" [alt]="'Go back' | translate" />
      </div>
      <h1 class="genie-page-title">{{ 'Discounts' | translate }}</h1>
      <p class="genie-page-subtitle">{{ 'Create and manage time-based sales and promotions.' | translate }}</p>
    </div>
  </div>

  <!-- Content Card -->
  <div class="genie-content-card">

    <!-- Empty State -->
    <div class="discount-empty-state" *ngIf="!hasdiscounts()">
      <div class="empty-image">
        <img loading="lazy" src="assets/images/discount.png" [alt]="'No discounts' | translate" />
      </div>
      <h3 class="empty-title">{{ 'No Discounts yet' | translate }}</h3>
      <p class="empty-subtitle">{{ 'Create your first sale to boost conversions and attract more customers. Discounts can be scheduled for specific dates and applied as percentage or fixed offers.' | translate }}</p>
      <button class="genie-btn primary" (click)="validateDiscount()">
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.36589 0.699219V10.0326M0.699219 5.36589H10.0326" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        {{ 'Create Discount' | translate }}
      </button>
    </div>

    <!-- Table Section -->
    <div class="table-section" *ngIf="hasdiscounts()">

      <!-- Toolbar -->
      <div class="genie-toolbar">
        <div class="toolbar-left">

          <!-- Filter Dropdown -->
          <div class="filter-dropdown" (click)="$event.stopPropagation()">
            <button class="filter-btn" (click)="toggleFilterDropdown($event)">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 2.5L5.5 2.5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M3.5 2.5H1" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11 6H8.5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.5 6H1" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11 9.5H5.5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M3.5 9.5H1" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.5 10.5V8.5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.5 3.5V1.5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.5 7V5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span>{{ getFilterLabel() }}</span>
              <svg class="arrow" [class.open]="showFilterDropdown" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.95906 4.47461L6.69906 7.73461C6.31406 8.11961 5.68406 8.11961 5.29906 7.73461L2.03906 4.47461" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
            <div class="dropdown-panel" *ngIf="showFilterDropdown">
              <div class="dropdown-options">
                <div class="dropdown-option" [class.selected]="selectedStateFilter === 'all'" (click)="selectFilter('all')">{{ 'All Discounts' | translate }}</div>
                <div class="dropdown-option" [class.selected]="selectedStateFilter === 'Active'" (click)="selectFilter('Active')">{{ 'Active' | translate }}</div>
                <div class="dropdown-option" [class.selected]="selectedStateFilter === 'Expired'" (click)="selectFilter('Expired')">{{ 'Expired' | translate }}</div>
              </div>
            </div>
          </div>

          <!-- Search Input -->
          <div class="search-input-wrapper">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.75 10.5C8.37335 10.5 10.5 8.37335 10.5 5.75C10.5 3.12665 8.37335 1 5.75 1C3.12665 1 1 3.12665 1 5.75C1 8.37335 3.12665 10.5 5.75 10.5Z" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M11 11L10 10" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <input
              type="text"
              [placeholder]="'Search Discount' | translate"
              [(ngModel)]="searchTerm"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="applyFilter($event)"
            />
          </div>
        </div>

        <div class="toolbar-right">
          <button class="genie-btn primary" (click)="validateDiscount()">
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.36589 0.699219V10.0326M0.699219 5.36589H10.0326" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            {{ 'Create Discount' | translate }}
          </button>
        </div>
      </div>

      <!-- Data Table -->
      <div class="genie-table-wrapper">
        <table class="genie-table">
          <thead>
            <tr>
              <th>{{ 'Name' | translate }}</th>
              <th>{{ 'Amount' | translate }}</th>
              <th>{{ 'Discount Criteria' | translate }}</th>
              <th>{{ 'Start Discount' | translate }}</th>
              <th>{{ 'End Discount' | translate }}</th>
              <th>{{ 'State' | translate }}</th>
              <th class="col-actions"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let discount of displayedDiscounts">
              <td>{{ $any(discount).discountName }}</td>
              <td>{{ $any(discount).discountPercentage }} %</td>
              <td>{{ discountCriteriaMap[$any(discount).discountCriteria] }}</td>
              <td>{{ $any(discount).dateFrom | date: 'yyyy-MM-dd' }}</td>
              <td>{{ $any(discount).dateTo | date: 'yyyy-MM-dd' }}</td>
              <td>
                <span class="genie-badge"
                  [ngClass]="{
                    'success': discountStates[$any(discount).id] === 'Active',
                    'danger': discountStates[$any(discount).id] === 'Expired'
                  }">
                  {{ discountStates[$any(discount).id] }}
                </span>
              </td>
              <td class="col-actions">
                <div class="genie-action-buttons">
                  <button class="genie-icon-btn edit" [routerLink]="['/discount/add-discount', discount.id]">
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.25996 11.8369L11.8369 4.25996C12.1913 3.90555 12.3685 3.72834 12.4633 3.53718C12.6435 3.17347 12.6435 2.74645 12.4633 2.38274C12.3685 2.19158 12.1913 2.01437 11.8369 1.65996C11.4825 1.30555 11.3053 1.12834 11.1141 1.03361C10.7504 0.85338 10.3234 0.85338 9.95967 1.03361C9.76851 1.12834 9.59132 1.30555 9.23694 1.65996L1.65996 9.2369C1.28422 9.6126 1.09635 9.80051 0.997394 10.0394C0.898438 10.2783 0.898438 10.544 0.898438 11.0754V12.5984H2.42148C2.95286 12.5984 3.21855 12.5984 3.45745 12.4994C3.69635 12.4005 3.88422 12.2126 4.25996 11.8369Z" stroke="#ADADAD" stroke-width="1.4625" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M6.75 12.5996H10.65" stroke="#ADADAD" stroke-width="1.4625" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M8.375 2.52344L10.975 5.12344" stroke="#ADADAD" stroke-width="1.4625" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </button>
                  <button class="genie-icon-btn delete" (click)="openDeleteModal(discount.id!, $any(discount).discountName)">
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.53438 3.13438V2.65438C8.53438 1.98231 8.53438 1.64628 8.40358 1.38959C8.28854 1.16379 8.10496 0.980215 7.87916 0.865167C7.62247 0.734375 7.28644 0.734375 6.61438 0.734375H5.65438C4.98231 0.734375 4.64628 0.734375 4.38959 0.865167C4.16379 0.980215 3.98022 1.16379 3.86517 1.38959C3.73438 1.64628 3.73438 1.98231 3.73438 2.65438V3.13438M4.93438 6.43438V9.43438M7.33438 6.43438V9.43438M0.734375 3.13438H11.5344M10.3344 3.13438V9.85438C10.3344 10.8625 10.3344 11.3665 10.1382 11.7516C9.96562 12.0903 9.69025 12.3656 9.35156 12.5382C8.96652 12.7344 8.46247 12.7344 7.45438 12.7344H4.81438C3.80628 12.7344 3.30223 12.7344 2.91719 12.5382C2.5785 12.3656 2.30314 12.0903 2.13056 11.7516C1.93437 11.3665 1.93438 10.8625 1.93438 9.85438V3.13438" stroke="#ADADAD" stroke-width="1.467" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Custom Pagination -->
      <div class="genie-pagination">
        <div class="pagination-info">
          <span class="current-page">{{ pageIndex + 1 }}</span>
          <span class="page-separator">of</span>
          <span class="total-pages">{{ getTotalPages() }}</span>
        </div>
        <div class="pagination-controls">
          <button class="page-btn prev" [disabled]="pageIndex === 0" (click)="previousPage()">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.25 7.5L3.75 5L6.25 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <button class="page-btn next" [disabled]="pageIndex >= getTotalPages() - 1" (click)="nextPage()">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.75 7.5L6.25 5L3.75 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
      </div>

    </div>
  </div>
</div>

<app-delete-confirm-modal
  [visible]="showDeleteModal"
  [itemName]="discountToDeleteName"
  itemType="Discount"
  (confirmed)="confirmDeleteDiscount()"
  (cancelled)="closeDeleteModal()">
</app-delete-confirm-modal>
